// extracted by mini-css-extract-plugin
module.exports = {"label":"Aff_label__1n2eg","control":"Aff_control__YdcAK","no-feeds":"Aff_no-feeds__1_zJt"};